import './index.css';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import TagManager from "react-gtm-module";
import { initGTM } from './utils/gtm';
import store from './redux/store';

const tagManagerArgs = {
  gtmId: "GTM-PM832V2W", // Replace with your GTM ID
};

TagManager.initialize(tagManagerArgs);
initGTM();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>

        <App />
      </BrowserRouter>

    </Provider>
  </HelmetProvider>
);
